import classNames from 'classnames'

import { currencyFromSymbol } from 'shared/currency-utilities'
import { RateCurrency } from 'booking/components/utilities'

import eventStyles from '../styles.module.scss'
import styles from 'booking/components/BookingView/components/styles.module.scss'

const DateInfo = ({ bookingData }) => (
    <div className={eventStyles.eventDateSection}>
        <div>
            <span className={eventStyles.dateLabel}>
                <T>booking.review.pay.data.start</T>:{' '}
            </span>
            <span>{bookingData.date.startDate.format('DD-MM-YYYY h:mm A')}</span>
        </div>
        <div>
            <span className={eventStyles.dateLabel}>
                <T>booking.review.pay.data.end</T>:{' '}
            </span>
            <span>{bookingData.date.endDate.format('DD-MM-YYYY h:mm A')}</span>
        </div>
    </div>
)

const VehicleEventDescription = ({ bookingData }) => (
    <div className={eventStyles.vehicleSelection}>
        <div className="d-flex justify-content-between">
            <span className={eventStyles.eventName}>{bookingData.event.eventName}</span>
            <div>
                <span className={classNames(styles.rateAmount, 'font-weight-bold')}>
                    <RateCurrency
                        rate={bookingData.event}
                        value={bookingData.event.amount}
                        currency={currencyFromSymbol(bookingData.event.currencySymbol)}
                    />
                </span>
            </div>
        </div>
        <DateInfo bookingData={bookingData} />
    </div>
)

export default VehicleEventDescription
